var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotOffered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M12.361 11.068l.086.038 4 2a1 1 0 0 1 .55.813L17 14v4.764a1 1 0 0 1-.482.855l-.07.04-4 2a1 1 0 0 1-.81.037l-.085-.038-4-2a1 1 0 0 1-.55-.813L7 18.764V14a1 1 0 0 1 .482-.855l.07-.04 4-2a1 1 0 0 1 .81-.037zM8 14.35v4.414l3.5 1.749v-4.22L8 14.35zm8-.001l-3.5 1.944v4.22l3.5-1.75V14.35zM12 12l-3.247 1.624L12 15.428l3.247-1.805L12 12zm7.778-6.778c1.414 1.414-.236 3.064-4.95 4.95 1.886-4.714 3.536-6.364 4.95-4.95zm-10.606 4.95c-4.714-1.886-6.364-3.536-4.95-4.95 1.414-1.414 3.064.236 4.95 4.95zM12 2c2 0 2 2.333 0 7-2-4.667-2-7 0-7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotOffered);
export default __webpack_public_path__ + "static/media/not-offered.6c5b34c787bc791e173a44c286495998.svg";
export { ForwardRef as ReactComponent };